import { Controller } from "react-hook-form";
import { Input } from "@/components/ui/input";
import { FieldShell, type FieldComponentProps } from "./field-shell";

export function EmailField({ field, control, disabled }: FieldComponentProps) {
  if (field.kind !== "email") return null;
  return (
    <Controller
      name={field.name}
      control={control}
      render={({ field: f, fieldState }) => (
        <FieldShell
          id={f.name}
          label={field.label}
          required={field.required}
          helpText={field.helpText}
          error={fieldState.error?.message}
        >
          <Input
            id={f.name}
            type="email"
            value={f.value == null ? "" : String(f.value)}
            onChange={(e) => f.onChange(e.target.value)}
            onBlur={f.onBlur}
            placeholder={field.placeholder}
            autoComplete="email"
            disabled={disabled}
            aria-invalid={!!fieldState.error}
          />
        </FieldShell>
      )}
    />
  );
}
